"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var DEFAULT_MAX_NUMBER_OF_WORDS = {
  vocab: 5,
  gender: 10,
  plural: 10,
  conjugation: 5,
  number: 12
};
var WORD_TYPES = {
  vocab: 'words',
  gender: 'nouns',
  plural: 'nouns',
  conjugation: 'verbs',
  number: 'numbers'
};
var VocabOptionsWrapper = function VocabOptionsWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "deckIsBeingCreated", _descriptor, _this);
      _initializerDefineProperty(_this, "loadingUser", _descriptor2, _this);
      _initializerDefineProperty(_this, "useCurrentFilter", _descriptor3, _this);
      _initializerDefineProperty(_this, "cardsNotFound", _descriptor4, _this);
      _initializerDefineProperty(_this, "setMaxWordsValue", _descriptor5, _this);
      _initializerDefineProperty(_this, "tenses", _descriptor6, _this);
      _initializerDefineProperty(_this, "pronouns", _descriptor7, _this);
      _initializerDefineProperty(_this, "conjugationFilterSeen", _descriptor8, _this);
      _initializerDefineProperty(_this, "genderFilterSeen", _descriptor9, _this);
      _initializerDefineProperty(_this, "pluralFilterSeen", _descriptor10, _this);
      _initializerDefineProperty(_this, "numberFilterSeen", _descriptor11, _this);
      _initializerDefineProperty(_this, "includeSentenceCards", _descriptor12, _this);
      _state.AppUI.loadUser(_this.afterLoadUser);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "maxWordsField",
      get: function get() {
        var maxWords = {
          vocab: 'maxNumberOfVocabWords',
          gender: 'maxNumberOfGenderWords',
          plural: 'maxNumberOfPluralWords',
          conjugation: 'maxNumberOfConjugationWords',
          number: 'maxNumberOfNumberWords'
        };
        return maxWords[this.props.type];
      }
    }, {
      key: "maxWordsValue",
      get: function get() {
        return (0, _utils.isPresent)(this.setMaxWordsValue) ? this.setMaxWordsValue : this.maxWords;
      }
    }, {
      key: "maxWords",
      get: function get() {
        return _state.AppUI.user[this.maxWordsField];
      }
    }, {
      key: "filterWasSet",
      get: function get() {
        var selectedFilterKeys = this.filterSettingsForVocabOptions.filter(function (item) {
          return item.value;
        }).map(function (item) {
          return item.key;
        });
        return (0, _utils.isPresent)(this.props.selectedWordIds) || (0, _utils.isPresent)(selectedFilterKeys);
      }
    }, {
      key: "maxWordsOptions",
      get: function get() {
        var maxWordsRange = {
          vocab: (1, 13),
          gender: (1, 13),
          plural: (1, 13),
          conjugation: (1, 13),
          number: (1, 13)
        };
        return (0, _lodash.range)(maxWordsRange[this.props.type]).filter(function (item) {
          return item !== 0;
        }).map(function (item) {
          return [item, item];
        });
      }
    }, {
      key: "seenOptions",
      get: function get() {
        return [[true, 'Yes'], [false, 'No']];
      }
    }, {
      key: "seenValue",
      get: function get() {
        switch (this.props.type) {
          case 'conjugation':
            return this.conjugationFilterSeen;
          case 'gender':
            return this.genderFilterSeen;
          case 'plural':
            return this.pluralFilterSeen;
          case 'number':
            return this.numberFilterSeen;
          default:
            return null;
        }
      }
    }, {
      key: "onChangeSeen",
      value: function onChangeSeen(val) {
        switch (this.props.type) {
          case 'conjugation':
            _state.AppUI.authUserStore.update({
              data: {
                conjugationFilterSeen: val
              }
            }, _lodash.noop);
            _state.AppUI.user.set('conjugationFilterSeen', val);
            this.conjugationFilterSeen = val;
            break;
          case 'gender':
            _state.AppUI.authUserStore.update({
              data: {
                genderFilterSeen: val
              }
            }, _lodash.noop);
            _state.AppUI.user.set('genderFilterSeen', val);
            this.genderFilterSeen = val;
            break;
          case 'plural':
            _state.AppUI.authUserStore.update({
              data: {
                pluralFilterSeen: val
              }
            }, _lodash.noop);
            _state.AppUI.user.set('pluralFilterSeen', val);
            this.pluralFilterSeen = val;
            break;
          case 'number':
            _state.AppUI.authUserStore.update({
              data: {
                numberFilterSeen: val
              }
            }, _lodash.noop);
            _state.AppUI.user.set('numberFilterSeen', val);
            this.numberFilterSeen = val;
            break;
          default:
            break;
        }
      }
    }, {
      key: "filterSettingsForVocabOptions",
      get: function get() {
        var filters = this.props.filterSettings.filter(function (item) {
          return item.key !== 'seen' || item.value === true;
        });
        if (this.props.type !== 'vocab') {
          filters = filters.filter(function (item) {
            return item.key !== 'root_word_type_id';
          });
        }
        if (this.props.type === 'number') {
          filters = filters.filter(function (item) {
            return item.key !== 'level_id';
          });
        }
        return filters;
      }
    }, {
      key: "showWordType",
      get: function get() {
        return this.props.filters['root_word_type_id'] && this.props.type !== 'gender' && this.props.type !== 'plural';
      }
    }, {
      key: "tenseOptions",
      get: function get() {
        var tenses = _constants.Constants.GRAMMAR_TENSES[_state.AppUI.targetLanguageId || 'DE'];
        return (0, _lodash.keys)(tenses).map(function (item) {
          return [item, tenses[item]];
        });
      }
    }, {
      key: "pronounOptions",
      get: function get() {
        var pronouns = _constants.Constants.PRONOUN_STRINGS[_state.AppUI.targetLanguageId || 'DE'];
        return (0, _lodash.keys)(pronouns).map(function (item) {
          return [item, pronouns[item]];
        });
      }
    }, {
      key: "onCreateDeck",
      value: function onCreateDeck(params, callback) {
        this.callback = callback;
        this.deckIsBeingCreated = true;
        var data = this.useCurrentFilter ? {
          filters: this.props.filters,
          word_ids: this.props.selectedWordIds
        } : {
          filters: {
            root: true,
            video_clip_id: true
          }
        };
        data[this.props.type] = true;
        data['max_words'] = this.maxWordsValue;
        if (this.props.type === 'conjugation') {
          data['pronouns'] = this.pronouns;
          data['tenses'] = this.tenses;
        }
        data['language_id'] = _state.AppUI.targetLanguageId || 'DE';
        if (this.props.type !== 'vocab') {
          data['root_word_type_id'] = 'd5c5fcef-bb92-48a8-b00b-e7c71cb33068';
        }
        _state.AppUI.deckStore.create({
          data: data
        }, this.afterCreateDeck);
      }
    }, {
      key: "afterLoadUser",
      value: function afterLoadUser() {
        this.loadingUser = false;
      }
    }, {
      key: "afterCreateDeck",
      value: function afterCreateDeck(resp) {
        var _this2 = this;
        this.deckIsBeingCreated = false;
        if (!resp.cardsNotFound) {
          if (this.props.type === 'vocab') {
            _state.AppUI.user.set('freeVocabDecksAvailableCount', 0);
          } else if (this.props.type === 'gender') {
            _state.AppUI.user.set('freeGenderDecksAvailableCount', 0);
          } else if (this.props.type === 'plural') {
            _state.AppUI.user.set('freePluralDecksAvailableCount', 0);
          } else if (this.props.type === 'number') {
            _state.AppUI.user.set('freeNumberDecksAvailableCount', 0);
          }
        }
        if (resp.cardsNotFound) {
          this.cardsNotFound = true;
          setTimeout(function () {
            return _this2.cardsNotFound = false;
          }, 8000);
        } else if (!_state.AppUI.layout.isNative) {
          _state.VocabUI.clearSelectedWords();
          _state.AppUI.onSetVocabModal(null);
          _state.AppUI.routeStore.routeToNamed('vocab.decks.show', {
            deckId: resp.id
          });
        } else if (this.callback) {
          _state.VocabUI.clearSelectedWords();
          _state.AppUI.onSetVocabModal(null);
          this.callback(resp.id);
        }
      }
    }, {
      key: "cardsNotFoundMessage",
      get: function get() {
        var wordType;
        if (this.props.type === 'gender' || this.props.type === 'plural') {
          wordType = 'nouns';
        } else if (this.props.type === 'conjugation') {
          wordType = 'verbs';
        } else if (this.props.type === 'number') {
          wordType = 'numbers';
        }
        return "No ".concat((0, _utils.isPresent)(wordType) ? wordType : 'words', " were found using these filters.");
      }
    }, {
      key: "toggleUseCurrentFilter",
      value: function toggleUseCurrentFilter() {
        this.useCurrentFilter = !this.useCurrentFilter;
      }
    }, {
      key: "toggleIncludeSentenceCards",
      value: function toggleIncludeSentenceCards() {
        this.includeSentenceCards = !this.includeSentenceCards;
        _state.AppUI.authUserStore.update({
          data: {
            conjugationFilterIncludeSentenceCards: this.includeSentenceCards
          }
        }, _lodash.noop);
        _state.AppUI.user.set('conjugationFilterIncludeSentenceCards', this.includeSentenceCards);
      }
    }, {
      key: "onChangeMaxWords",
      value: function onChangeMaxWords(val) {
        if ((0, _lodash.isArray)(val)) {
          val = val[0];
        }
        if ((0, _utils.isBlank)(val)) {
          val = DEFAULT_MAX_NUMBER_OF_WORDS[this.props.type];
        }
        _state.AppUI.user.set(this.maxWordsField, val);
        this.setMaxWordsValue = val;
      }
    }, {
      key: "onChangeTense",
      value: function onChangeTense(val) {
        var ary = (0, _utils.isPresent)(this.tenses) ? this.tenses.split(',') : [];
        if ((0, _lodash.isEmpty)(val)) {
          ary = [];
        } else if (ary.includes(val)) {
          ary = ary.filter(function (item) {
            return item !== val;
          });
        } else {
          ary.push(val);
        }
        var newValue = (0, _lodash.keys)(_constants.Constants.GRAMMAR_TENSES[_state.AppUI.targetLanguageId || 'DE']).filter(function (item) {
          return ary.includes(item);
        }).join(',');
        _state.AppUI.user.set('conjugationFilterTense', newValue);
        this.tenses = newValue;
      }
    }, {
      key: "onChangePronoun",
      value: function onChangePronoun(val) {
        var ary = (0, _utils.isPresent)(this.pronouns) ? this.pronouns.split(',') : [];
        if ((0, _lodash.isEmpty)(val)) {
          ary = [];
        } else if (ary.includes(val)) {
          ary = ary.filter(function (item) {
            return item !== val;
          });
        } else {
          ary.push(val);
        }
        var newValue = (0, _lodash.keys)(_constants.Constants.PRONOUN_STRINGS[_state.AppUI.targetLanguageId || 'DE']).filter(function (item) {
          return ary.includes(item);
        }).join(',');
        _state.AppUI.user.set('conjugationFilterPronoun', newValue);
        this.pronouns = newValue;
      }
    }, {
      key: "onHideAlreadySeenWordsMessage",
      value: function onHideAlreadySeenWordsMessage() {
        _state.AppUI.authUserStore.update({
          data: {
            hideAlreadySeenWordsMessage: true
          }
        }, _lodash.noop);
        _state.AppUI.user.set('hideAlreadySeenWordsMessage', true);
      }
    }, {
      key: "advancedFilterSettings",
      get: function get() {
        var filters = [];
        if (this.props.type === 'conjugation') {
          filters.push({
            name: 'Pronouns',
            type: 'MultiSelect',
            options: this.pronounOptions,
            value: this.pronouns,
            onChange: this.onChangePronoun,
            tagDisplay: (0, _utils.isPresent)(this.pronouns) ? this.pronouns.split(',').map(function (item) {
              return _constants.Constants.PRONOUN_STRINGS[_state.AppUI.targetLanguageId || 'DE'][item];
            }).join(', ') : '',
            placeholder: 'Any Pronoun',
            compact: true,
            hideIfWordsSelected: false
          });
        }
        if (this.props.type === 'conjugation') {
          filters.push({
            name: 'Tenses',
            type: 'MultiSelect',
            options: this.tenseOptions,
            value: this.tenses,
            onChange: this.onChangeTense,
            tagDisplay: (0, _utils.isPresent)(this.tenses) ? this.tenses.split(',').map(function (item) {
              return _constants.Constants.GRAMMAR_TENSES[_state.AppUI.targetLanguageId || 'DE'][item];
            }).join(', ') : '',
            placeholder: 'Any Tense',
            compact: true,
            hideIfWordsSelected: false
          });
        }
        if (this.props.type === 'conjugation') {
          filters.push({
            name: 'Include Sentence Cards',
            type: 'checkbox',
            value: this.includeSentenceCards,
            onChange: this.toggleIncludeSentenceCards,
            tagDisplay: this.includeSentenceCards ? '' : 'No Sentence Cards',
            compact: true,
            compactString: 'Include Sentence Cards',
            hideIfWordsSelected: false
          });
        }
        if (this.props.selectedWordIds) {
          filters.push({
            name: 'Max Number of Words',
            type: 'Slider',
            value: this.maxWordsValue,
            options: this.maxWordsOptions,
            onChange: this.onChangeMaxWords,
            tagDisplay: this.maxWordsValue !== DEFAULT_MAX_NUMBER_OF_WORDS[this.props.type] ? "".concat(this.maxWordsValue, " Words") : '',
            compact: true,
            compactString: "".concat(this.maxWordsValue, " Word").concat(this.maxWordsValue > 1 ? 's' : '', " in Deck"),
            hideIfWordsSelected: true
          });
        }
        // if (this.props.type !== 'vocab') {
        //   filters.push(
        //     {
        //       name: `Seen in a ${capitalize(this.props.type)} Trainer`,
        //       type: 'InPlaceSelect',
        //       value: this.seenValue,
        //       options: this.seenOptions,
        //       onChange: this.onChangeSeen,
        //       tagDisplay: isBlank(this.seenValue) ? '' : `${this.seenValue ? '' : 'Not '}Seen in a ${capitalize(this.props.type)} Trainer`,
        //       hideIfWordsSelected: true,
        //     },
        //   );
        // }
        return filters;
      }
    }, {
      key: "filteredAdvancedFilterSettings",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.selectedWordIds) && this.useCurrentFilter) {
          return this.advancedFilterSettings.filter(function (item) {
            return !item.hideIfWordsSelected;
          });
        }
        return this.advancedFilterSettings;
      }
    }, {
      key: "spinnerText",
      get: function get() {
        return this.props.trainerIsCompleted || this.props.type === 'number' ? "Loading random ".concat(WORD_TYPES[this.props.type], " that match your filters...") : "Loading the most frequent new ".concat(WORD_TYPES[this.props.type], " that match your filters...");
      }
    }, {
      key: "buttonText",
      get: function get() {
        return "Practice ".concat((0, _lodash.capitalize)(_state.AppUI.showVocabModal)).concat(_state.AppUI.showVocabModal === 'vocab' ? '' : 's');
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          loadingUser: this.loadingUser,
          useCurrentFilter: this.useCurrentFilter,
          toggleUseCurrentFilter: this.toggleUseCurrentFilter,
          showWordType: this.showWordType,
          onCreateDeck: this.onCreateDeck,
          maxWordsOptions: this.maxWordsOptions,
          cardsNotFound: this.cardsNotFound,
          cardsNotFoundMessage: this.cardsNotFoundMessage,
          deckIsBeingCreated: this.deckIsBeingCreated,
          filterWasSet: this.filterWasSet,
          filterSettingsForVocabOptions: this.filterSettingsForVocabOptions,
          onHideAlreadySeenWordsMessage: this.onHideAlreadySeenWordsMessage,
          advancedFilterSettings: this.filteredAdvancedFilterSettings,
          onChangeMaxWords: this.onChangeMaxWords,
          maxWordsValue: this.maxWordsValue,
          wordType: WORD_TYPES[this.props.type],
          spinnerText: this.spinnerText,
          buttonText: this.buttonText
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "deckIsBeingCreated", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "loadingUser", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "useCurrentFilter", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "cardsNotFound", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "setMaxWordsValue", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "tenses", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.AppUI.user.conjugationFilterTense;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "pronouns", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.AppUI.user.conjugationFilterPronoun;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "conjugationFilterSeen", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.AppUI.user.conjugationFilterSeen;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "genderFilterSeen", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.AppUI.user.genderFilterSeen;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "pluralFilterSeen", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.AppUI.user.pluralFilterSeen;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "numberFilterSeen", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.AppUI.user.numberFilterSeen;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "includeSentenceCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return _state.AppUI.user.conjugationFilterIncludeSentenceCards;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "maxWordsField", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "maxWordsField"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "maxWordsValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "maxWordsValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "maxWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "maxWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterWasSet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterWasSet"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "maxWordsOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "maxWordsOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "seenOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "seenOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "seenValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "seenValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeSeen", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeSeen"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterSettingsForVocabOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterSettingsForVocabOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tenseOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tenseOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pronounOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pronounOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCreateDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCreateDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterLoadUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterLoadUser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCreateDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCreateDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardsNotFoundMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardsNotFoundMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleUseCurrentFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleUseCurrentFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleIncludeSentenceCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleIncludeSentenceCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeMaxWords", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeMaxWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeTense", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeTense"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangePronoun", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangePronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onHideAlreadySeenWordsMessage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onHideAlreadySeenWordsMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "advancedFilterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "advancedFilterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filteredAdvancedFilterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filteredAdvancedFilterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "spinnerText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "spinnerText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "buttonText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "buttonText"), _class2.prototype), _class2)) || _class;
};
VocabOptionsWrapper.displayName = 'VocabOptionsWrapper';
var _default = exports["default"] = VocabOptionsWrapper;